import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { BootSplash } from "@/components/boot-splash";

import { router } from "./routes";

import "./styles/fonts.css";
import "./styles/globals.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root element missing from index.html");
}

// `fallbackElement` paints during initial-load loader resolution so
// users don't stare at the empty (or inline-splash) #root while
// `dashboardLoader` runs `/v1/me`. The inline splash in `index.html`
// covers the JS-bundle window before React even mounts; this React
// splash covers the gap between mount and first route render.
createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} fallbackElement={<BootSplash />} />
  </StrictMode>,
);
